import React, { useContext } from 'react'
import { useParams } from 'react-router-dom'
import { FilterContext } from '../../Context/FilterContext'

const filterUrl = `https://zomatourl.herokuapp.com/filter`

const CostFilter = () => {
    const { setRestaurants } = useContext(FilterContext)
    const params = useParams();
    const mealId = params.id;

    const costfilter = (e) => {
        let lcost = e.target.value.split("-")[0]
        let hcost = e.target.value.split("-")[1]
        fetch(`${filterUrl}/${mealId}?lcost=${lcost}&hcost=${hcost}`)
            .then(res => res.json())
            .then(data => {
                setRestaurants(data)
            })
            .catch(err => {
                console.log(err);
            })

    }
    return (
        <div className="cost mt-4" onChange={costfilter}>
            <h6>Cost For Two</h6>
            <div className="less-than-500">
                <label htmlFor="less-than-500" >
                    <input type="radio" name="cost" id="less-than-500" value="1-500" className='me-2' />
                    Less than 500
                </label>
            </div>
            <div className="500-1000">
                <label htmlFor="500-1000" >
                    <input type="radio" name="cost" id="500-1000" value="500-1000" className='me-2' />
                    500 to 1000
                </label>
            </div>
            <div className="1000-1500">
                <label htmlFor="1000-1500" >
                    <input type="radio" name="cost" id="1000-1500" value="1000-1500" className='me-2' />
                    1000 to 1500
                </label>
            </div>
            <div className="1500-2000">
                <label htmlFor="1500-2000" >
                    <input type="radio" name="cost" id="1500-2000" value="1500-2000" className='me-2' />
                    1500 to 2000
                </label>
            </div>
            <div className="2000+">
                <label htmlFor="2000+" >
                    <input type="radio" name="cost" id="2000+" value="2000-5000" className='me-2' />
                    2000+
                </label>
            </div>
        </div>
    )
}

export default CostFilter;